function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  z-index: 10;\n\n  pointer-events: all;\n\n  ", " {\n    z-index: 999;\n  }\n\n  ", " {\n    transform-origin: top center;\n    transform: ", ";\n  }\n\n  ", "\n\n  ", " {\n    ", " {\n      position: fixed;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      transform-origin: left center;\n      transform: ", ";\n    }\n\n    ", " {\n      margin: 0 1rem 1rem;\n      align-items: center;\n\n      display: -ms-grid;\n      display: grid;\n      -ms-grid-columns: auto 1fr auto;\n      grid-template-columns: auto 1fr auto;\n      -ms-grid-rows: auto;\n      grid-template-rows: auto;\n      grid-template-areas: 'left main right';\n\n      ", " {\n        -ms-grid-row: 1;\n        -ms-grid-column: 1;\n        -ms-grid-row-align: center;\n        grid-area: left;\n      }\n\n      ", " {\n        -ms-grid-row: 1;\n        -ms-grid-column: 2;\n        -ms-grid-row-align: center;\n        grid-area: main;\n      }\n\n      ", " {\n        -ms-grid-row: 1;\n        -ms-grid-column: 3;\n        -ms-grid-row-align: center;\n        grid-area: right;\n      }\n    }\n\n    ", " {\n      ", " {\n        padding: 0 1rem 0;\n      }\n\n      ", " {\n        margin: 0 1rem 0;\n      }\n    }\n\n    ", " {\n      margin: 1rem 1rem 0;\n      flex-direction: column;\n      align-items: stretch;\n\n      > *:not(:last-child) {\n        margin: 0 0 1rem 0;\n      }\n    }\n\n    ", " {\n      display: none;\n    }\n  }\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  position: absolute;\n\n  ", " {\n    height: 100%;\n    margin: 0 ", ";\n    padding: 1.5rem ", ";\n  }\n\n  ", " {\n    margin: 0 0 1.5rem;\n  }\n\n  ", " {\n    margin: 1.5rem 0 0;\n  }\n\n  ", " {\n    ", " {\n      padding: 1rem ", ";\n    }\n  }\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  ", " {\n    max-width: 100%;\n    padding: 1rem;\n  }\n\n  ", " {\n    margin: 0 0 1rem;\n  }\n\n  ", " {\n    margin: 1rem 0 0;\n  }\n\n  ", " {\n    top: 0.5rem;\n    right: 0.5rem;\n  }\n\n  ", " {\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    transform: translate(0, 0);\n  }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  transition: background-color 0.3s;\n  background-color: ", ";\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 5;\n  height: 100%;\n  overflow: hidden;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n      ", " {\n        display: block;\n        max-height: none;\n      }\n    "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  transition: all 0.3s;\n  max-height: ", ";\n  box-sizing: border-box;\n  border-radius: 0.1875rem;\n  box-shadow: 0 0.0625rem 0.125rem 0 rgba(0, 0, 0, 0.22), 0 0 0.0625rem 0 rgba(0, 0, 0, 0.32);\n  background-color: ", ";\n  margin: auto;\n\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: 1fr;\n  grid-template-columns: 1fr;\n  -ms-grid-rows: auto 1fr auto;\n  grid-template-rows: auto 1fr auto;\n  grid-template-areas: 'header' 'body' 'footer';\n\n  ", " {\n    -ms-grid-row: 1;\n    -ms-grid-column: 1;\n    grid-area: header;\n  }\n\n  ", " {\n    -ms-grid-row: 2;\n    -ms-grid-column: 1;\n    grid-area: body;\n  }\n\n  ", " {\n    -ms-grid-row: 3;\n    -ms-grid-column: 1;\n    grid-area: footer;\n  }\n\n  ", "\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n      ", " {\n        overflow-y: scroll;\n        height: 100%;\n        width: 100%;\n        display: flex;\n        flex-flow: column;\n        justify-content: space-between;\n        padding: 2rem 0;\n      }\n    "]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  pointer-events: all;\n\n  ", "\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  margin-left: 1rem;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: 1.33;\n  text-transform: capitalize;\n  color: ", ";\n  padding: 0;\n  margin: 0;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n\n  > *:not(:last-child) {\n    margin: 0 0.5rem 0 0;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-right: 1rem;\n  transform: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 0.5rem;\n  top: 0.5rem;\n  transition: right 0.3s;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import { Button } from "../button/Button";
import styled, { css, from, to } from "../../theme";
export var ModalClose = styled(Button)(_templateObject());
export var ModalBackButton = styled(Button)(_templateObject2(), function (props) {
  return props.rotateButton ? 'rotateZ(90deg)' : '';
});
export var ModalBody = styled.div(_templateObject3(), to('md'));
export var ModalFooter = styled.div(_templateObject4());
export var ModalHeader = styled.div(_templateObject5());
export var ModalTitle = styled.h1(_templateObject6(), function (props) {
  return props.theme.variables.typography.secondaryFont;
}, function (props) {
  return props.theme.variables.fonts.size.bigger0;
}, function (props) {
  return props.theme.variables.fonts.weight.bold;
}, function (props) {
  return props.theme.variables.colors.black;
});
export var ModalTools = styled.div(_templateObject7());
export var ModalScrollWrapper = styled.div(_templateObject8(), function (props) {
  return props.isFixed && css(_templateObject9(), from('md'));
});
export var ModalInnerContainer = styled.div(_templateObject10(), function (props) {
  return props.isFixed ? '100vh' : '100%';
}, function (props) {
  return props.theme.variables.colors.lightGrey;
}, ModalHeader, ModalBody, ModalFooter, function (props) {
  return props.isFixed && css(_templateObject11(), from('md'));
});
export var ModalOverlay = styled.div(_templateObject12(), function (props) {
  return props.isOpening || props.isClosing ? 'rgba(255, 255, 255, 0.0)' : 'rgba(255, 255, 255, 0.9)';
});
var modalFixed = css(_templateObject13(), ModalInnerContainer, ModalHeader, ModalFooter, ModalClose, function (p) {
  return to(p.breakpoint);
});
var modalRelative = css(_templateObject14(), ModalInnerContainer, function (props) {
  return props.isOpening || props.isClosing ? '0' : '-2.8rem';
}, function (props) {
  return props.isOpening || props.isClosing ? '0' : '2.8rem';
}, ModalHeader, ModalFooter, function (p) {
  return to(p.breakpoint);
}, ModalInnerContainer, function (props) {
  return props.isOpening || props.isClosing ? '0' : '2.8rem';
});
export var ModalWrapper = styled.div(_templateObject15(), to('lg'), ModalInnerContainer, function (props) {
  return props.isOpening || props.isClosing ? 'scaleY(0)' : 'scaleY(1)';
}, function (props) {
  return props.isFixed ? modalFixed : modalRelative;
}, function (p) {
  return to(p.breakpoint);
}, ModalInnerContainer, function (props) {
  return props.isOpening || props.isClosing ? 'translateX(-100%)' : 'translateX(0)';
}, ModalHeader, ModalBackButton, ModalTitle, ModalTools, ModalBody, to('md'), from('md'), ModalFooter, ModalClose);